import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { FileX } from "lucide-react";

/** CR-162: shown when a bare `/docs/:id` link points at an unknown or unreadable document. */
export function DocumentNotFound() {
  return (
    <div
      className="flex h-[calc(100vh-4rem)] flex-col items-center justify-center gap-3 px-4 text-center"
      data-testid="document-not-found"
    >
      <FileX className="text-muted-foreground size-10" aria-hidden="true" />
      <h1 className="text-lg font-semibold">This document is not available</h1>
      <p className="text-muted-foreground max-w-sm text-sm">
        It may have been deleted, or you may not have access to it.
      </p>
      <Button asChild variant="outline" size="sm">
        <Link to="/workspaces">Go to your workspaces</Link>
      </Button>
    </div>
  );
}
